import { render, staticRenderFns } from "./DetalhesPauseGerenciamentoServico.vue?vue&type=template&id=c5e23a56&scoped=true"
import script from "./DetalhesPauseGerenciamentoServico.vue?vue&type=script&lang=js"
export * from "./DetalhesPauseGerenciamentoServico.vue?vue&type=script&lang=js"
import style0 from "./DetalhesPauseGerenciamentoServico.vue?vue&type=style&index=0&id=c5e23a56&prod&lang=css"
import style1 from "./DetalhesPauseGerenciamentoServico.vue?vue&type=style&index=1&id=c5e23a56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e23a56",
  null
  
)

export default component.exports